export class Claim {
  constructor(
    public ID: number,
    public InsurerID: number,
    public PolicyNumber: string,
    public ClaimNumber: string,
    public StatusID: number,
    public Status: string,
    public AssigneeID: number,
    public AssigneeName: string,
    public InsuredID: number,
    public AgentID: number,
    public ItemDetails: string,
    public SumInsured: number,
    public Excess: number,
    public IncidentDate: Date,
    public IncidentDetails: string,

    public Insurer: string,
    public AgentName: string,
    public AgenteMail: string,
    public AgentPhone: string,
    public InsuredName: string,
    public InsuredeMail: string,
    public InsuredPhone: string,
    public Bikes: Bike[],
    public Notes: Note[],
    public Age: string,
    public DueDate: string,
    public IncidentType?,
    public BikeSize?,
    public IncidentLocation?,
    public Attachments?,
    public DocumentLink?,
    public Quotes?,
    public Messages?
  ) { }


}


export interface Bike {
  ID: number,
  Name: string,
  Components: BikeComponent[],
  SumInsured: number,
  Excess: number,
}

export interface BikeComponent {
  ID: number,
  Description: string,
}

export interface Note {
  ID: number,
  ClaimID: number,
  DueDate: string,
  Description: string,
  Completed: boolean,
  Assignee: string,
  AssigneeID: number,
  IsStandardTask: number,
}

export interface Attachment {
  ID: number,
  ClaimID: number,
  FileName: string,
  FileURL: string,
  FileType: string,
  FileData: string,
}
